import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import DescriptionSection from '@/components/DescriptionSection';
import ReviewsSection from '@/components/ReviewsSection';
import FAQSection from '@/components/FAQSection';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';

const Index: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check for Cashfree payment return status
    const orderStatus = searchParams.get('order_status');
    const orderId = searchParams.get('order_id');
    
    if (orderId && orderStatus) {
      // Payment completed successfully - redirect to success page
      if (orderStatus === 'PAID' || orderStatus === 'SUCCESS') {
        navigate('/payment-success', { replace: true });
        return;
      }
      
      // Payment failed, cancelled, or user dropped - redirect to failed page
      if (orderStatus === 'FAILED' || orderStatus === 'CANCELLED' || 
          orderStatus === 'USER_DROPPED' || orderStatus === 'PENDING' ||
          orderStatus === 'EXPIRED' || orderStatus === 'VOID') {
        navigate('/payment-failed', { replace: true });
        return;
      }
    }
  }, [searchParams, navigate]);

  return (
    <>
      <SEOHead />

      <div className="flex min-h-screen flex-col bg-background">
        <Header />
        <main role="main" aria-label="Main content" className="flex-1">
          <HeroSection />
          <DescriptionSection />
          <ReviewsSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
      
      <WhatsAppButton />
    </>
  );
};

export default Index;
